/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_IncompleteInputs */

const en_us2_workout_after_incomplete = /** @type {(inputs: Workout_After_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer energy, difficulty and length.`)
};

const pt_br2_workout_after_incomplete = /** @type {(inputs: Workout_After_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responda energia, dificuldade e duração.`)
};

const es_419_workout_after_incomplete = /** @type {(inputs: Workout_After_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde energía, dificultad y duración.`)
};

const pt_pt2_workout_after_incomplete = /** @type {(inputs: Workout_After_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde à energia, à dificuldade e à duração.`)
};

const fr_fr2_workout_after_incomplete = /** @type {(inputs: Workout_After_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponds pour l'énergie, la difficulté et la durée.`)
};

const de_de2_workout_after_incomplete = /** @type {(inputs: Workout_After_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantworte Energie, Schwierigkeit und Dauer.`)
};

const it_it2_workout_after_incomplete = /** @type {(inputs: Workout_After_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispondi su energia, difficoltà e durata.`)
};

/**
* | output |
* | --- |
* | "Answer energy, difficulty and length." |
*
* @param {Workout_After_IncompleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_incomplete = /** @type {((inputs?: Workout_After_IncompleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_IncompleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_incomplete(inputs)
	if (locale === "es-419") return es_419_workout_after_incomplete(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_incomplete(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_incomplete(inputs)
	if (locale === "de-DE") return de_de2_workout_after_incomplete(inputs)
	if (locale === "it-IT") return it_it2_workout_after_incomplete(inputs)
	return en_us2_workout_after_incomplete(inputs)
});
export { workout_after_incomplete as "workout-after.incomplete" }